import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { decorationMobx } from '@mobxStore'
import { useHistoryNew } from '@utils'
import { find } from '@dt/fe-utils/dist/lodash'
import './index.scss'

interface IProps { }

const ActivityReserveModule: FC<IProps> = () => {
  const history = useHistoryNew()
  const { mktDecorates } = decorationMobx
  let info: any = find(mktDecorates.market, (item: any) => item.key === 'activityReserve')
  if (!info) {
    info = find(mktDecorates.notMarket, (item: any) => item.key === 'activityReserve') || {}
  }
  const handleGo = () => {
    history.push('/activityReserve')
  }
  return (
    <div data-cypid='mmgToActivityReserve' className='activity-reserve-panel' onClick={handleGo}>
      {
        info.img ? (
          <>
            {
              !info.hideTitle &&
                <div className='activity-reserve-panel-block' style={{ color: info.titleColor || '#161616' }}>
                  <div className='title'>{info.title || i18n.t('mkt.activityReserve.title')}</div>
                </div>
            }
            <img src={info.img} alt='' />
          </>
        ) : (
          <div className='activity-reserve-default'>
            {!info.hideTitle && <div className='title' style={{ color: info.titleColor || '#161616' }}>{info.title || i18n.t('mkt.activityReserve.title')}</div>}
          </div>
        )
      }
    </div>
  )
}

export default observer(ActivityReserveModule)
